<template>
    <div>
        View Activity Page
    </div>
</template>

<script>
export default {
    
}
</script>